// ABOUTME: Shared sidebar link behaviour - which nav item is active for a path and the black-theme link class
// ABOUTME: Used by the nav groups in Sidebar.tsx and the user menu in SidebarUserMenu.tsx

import type { NavItem } from './sidebar-nav';

// A hub entry is active for any of its tabs, so match on `item.match` prefixes
// in addition to the item's own path. Non-hub items also light up on sub-paths.
export function isItemActive(item: NavItem, pathname: string): boolean {
  if (pathname === item.path) return true;
  if (item.match) return item.match.some((m) => pathname === m || pathname.startsWith(`${m}/`));
  return item.path !== '/' && pathname.startsWith(`${item.path}/`);
}

export const navLinkClass = (active: boolean, isCollapsed: boolean) =>
  `flex items-center gap-4 py-3 rounded-xl text-base font-medium transition-colors [&_svg]:w-6 [&_svg]:h-6 ${
    active ? 'bg-neutral-800 text-white' : 'text-neutral-400 hover:bg-neutral-900 hover:text-white'
  } ${isCollapsed ? 'justify-center px-2' : 'px-4'}`;
